import React from 'react';
import PlansSection from '../components/PlansSection';
import { Wifi, Download, Upload, Monitor, Smartphone, Tv } from 'lucide-react';
import { contactInfo } from '../mockData';

const ForYou = () => {
  const benefits = [
    {
      icon: Wifi,
      title: 'Wi-Fi de alta performance',
      description: 'Roteadores com tecnologia 5G e 6G para cobertura total'
    },
    {
      icon: Download,
      title: 'Velocidade real',
      description: 'A velocidade contratada é a velocidade entregue'
    },
    {
      icon: Upload,
      title: 'Upload rápido',
      description: 'Perfeito para lives, videoconferências e backups'
    },
    {
      icon: Monitor,
      title: 'Para trabalho',
      description: 'Estabilidade para home office e reuniões online'
    },
    {
      icon: Smartphone,
      title: 'Múltiplos dispositivos',
      description: 'Toda família conectada ao mesmo tempo'
    },
    {
      icon: Tv,
      title: 'Streaming em 4K',
      description: 'Assista suas séries e filmes favoritos sem travamentos'
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-orange-500 to-orange-600 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">Internet Para Você</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Planos residenciais com a melhor velocidade e estabilidade para sua casa
          </p>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
            Por que escolher a OpaLink?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div
                  key={index}
                  className="bg-gray-50 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-2"
                >
                  <div className="bg-orange-500 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                    <Icon className="text-white" size={32} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">{benefit.title}</h3>
                  <p className="text-gray-600">{benefit.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Plans Section */}
      <PlansSection />

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Pronto para se conectar?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Entre em contato agora e aproveite nossa oferta especial com 1º mês grátis!
          </p>
          <a
            href={contactInfo.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-orange-500 text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-orange-600 transition-all hover:scale-105 shadow-lg"
          >
            Fale conosco pelo WhatsApp
          </a>
        </div>
      </section>
    </div>
  );
};

export default ForYou;
